<template>
  <div id="agWfPage">
    <b-spinner v-if="isLoading" id="agWfPage-loadingSpinner"></b-spinner>
    <div id="agWfPage-noWss" v-else-if="workspaces.length == 0">
      <fa icon="briefcase" />
      <div>No workspaces have been created</div>
    </div>

    <div class="workspaces-container">
      <div
        v-for="ws in workspaces"
        :key="ws._id"
        class="workspace-cell"
      >
        <h2>{{ws.name}}</h2>
        <div class="table-scroll">
          <table v-if="!isLoading && ws.workflows.length > 0" :key="reload"  class="data-table table-container table-striped agWfPage">
            <thead>
              <tr>
                <th style="width:40px;"></th>
                <th><b>Name</b></th>
                <th>Send Email On Completion</th>
                <th>Email for Completion</th>
                <th>Last Successful Run</th>
                <th>Enabled</th>
                <th>Webhook Enabled</th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="workflow in ws.workflows"
                :key="workflow._id"
              >
                <td class="drag-handle" style="cursor: grab;">
                  <i class="fas fa-bars"></i>
                </td>
                <td><b>{{ workflow.name }}</b></td>
                <td>{{ workflow.sendEmail }}</td>
                <td>{{ workflow.email }}</td>
                <td>{{ new Date(workflow.lastSuccessfulRun)
                  .toLocaleString('en-US', {
                    year:   '2-digit',
                    month:  'numeric',
                    day:    'numeric',
                    hour:   'numeric',
                    minute: 'numeric',
                    hour12: true
                  })
                  .replace(',', '')  || " "
                }}</td>


                <td>
                  <ag-toggle
                    :on="workflow.enabled"
                    :label="'Enabled:'"
                    :labelPosition="'left'"
                    :disabled="isReadonly"
                    @toggled="enabledDisableWorkflow(workflow)">
                  </ag-toggle>
                </td>
                <td>
                  <ag-toggle
                    :on="workflow.webhookEnabled"
                    :label="'Enabled:'"
                    :labelPosition="'left'"
                    :disabled="isReadonly"
                    @toggled="enabledDisableWebhooks(workflow)">
                  </ag-toggle>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <td></td>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import AgToolbar from "../ui/Toolbar.vue"
import Server from "src/server";
import Util from "src/util/util";
import Draggable from "vuedraggable";
import Moment from "moment";
import { EventBus } from "src/eventBus";
import Toggle from "comp/ui/Toggle";


// @todo:cs on the test env, the table is creating essentially an infinite list
// of the workflows. Once done it loops through continually.
export default {
  name: "AgSummary",
  components: {
    "ag-toolbar": AgToolbar,
    "draggable": Draggable,
    "ag-toggle": Toggle
  },
  data(){
    return {
      reload: 0,
      isDeleting: false,
      workflowLoading: false,
      workspaceOptions: [],
      modalWorkspace: {
        name: "",
        description: "",
        owner: this.user,
        users: [],
        groups: []
      },
      sortedWorkflows: [],
      workflowLoading: false,
    };
  },
  computed: {

    isLoading() {
      if (
        this.$store.state.summary.isLoading ||
          this.$store.state.summary.isLoading ||
          this.isSaving ||
          this.isDeleting
      )
      return true;
      return false;
    },

    isReadonly() {
      if(this.user.role == "readonly")
      return true;
      return false;
    },

    user() {
      return this.$store.state.userStore.user;
    },
    workspaces() {
      const ws = this.$store.state.summary.workspaces;
      return ws
    },
  },
  watch: {
    workspaces() {
      //this.setWorkspaceOptions();
    },
  },

  created() {

  },
  mounted() {
    //this.setWorkspaceOptions();
    //this.setSortedWorkflows();
  },
  methods: {
    reloadWorkflows() {
      this.setSortedWorkflows();
      this.reload++;
    },
    formattedDate(workflow) {
      if (workflow.lastSuccessfulRun)
      return  Moment.calendarFormat()
      else
      return " "
    },
    //setWorkspaceOptions() {
    //  this.workspaceOptions = [];
    //  for (var i = 0; i < this.workspaces.length; i++) {
    //    var workspace = this.workspaces[i];
    //    this.workspaceOptions.push({
    //      value: workspace._id,
    //      text: workspace.name
    //    });
    //  }

    //  // select from userParms or first option if none selected
    //  if (this.workspaces.length > 0 && !this.workspace) {
    //    if (this.user.parms.workspace)
    //    var workspace = this.workspaces.find(
    //      a => a._id == this.user.parms.workspace
    //    );
    //    else {
    //      var workspace = this.workspaces[0];
    //    }
    //    this.$store.dispatch("wsStore/setWorkspace", { workspace: workspace });
    //  }
    //},

    //setSortedWorkflows() {
    //  this.sortedWorkflows = [];
    //  if (this.workflows.length == 0) {
    //    return;
    //  }

    //  var remaining = JSON.parse(JSON.stringify(this.workflows));
    //  // sort by user parm
    //  if (this.user.parms.workspaces) {
    //    var workspace = this.user.parms.workspaces.find(a => a.workspace == this.workspace);
    //    if(workspace) {
    //      var order = workspace.workflows;
    //      if (order) {
    //        for (var i = 0; i < order.length; i++) {
    //          var workflow = remaining.find(a => a._id == order[i]);
    //          if (workflow) {
    //            this.sortedWorkflows.push(workflow);
    //            remaining = Util.removeFromArrayByKey(
    //              remaining,
    //              "_id",
    //              workflow._id
    //            );
    //          }
    //        }
    //      }
    //    }
    //  }

    //  // add remaining
    //  for (var i = 0; i < remaining.length; i++) {
    //    this.sortedWorkflows.unshift(remaining[i]);
    //  }
    //},
    saveWorkflowOrder() {
      if (!this.user.parms.workspaces)
      this.user.parms.workspaces = [];

      if (this.workspace != "" && !!this.workspace) {
        var workspace = this.user.parms.workspaces.find(a => a.workspace == this.workspace);
        if(!workspace) {
          workspace = {
            workspace: this.workspace,
            workflows: [],
            connections: []
          };
          this.user.parms.workspaces.push(workspace);
        }

        workspace.workflows = []; // clear order
        for (var i = 0; i < this.sortedWorkflows.length; i++) {
          var workflow = this.sortedWorkflows[i];
          workspace.workflows.push(
            workflow._id
          );
        }

        this.$store.dispatch("userStore/updateUserParms", { user: this.user });
      }
      this.reload++;
    },

    enabledDisableWorkflow(workflow) {
      workflow.enabled = !workflow.enabled;
      this.$store.dispatch("wfStore/updateWorkflow", {workflow: workflow});
      this.reload++;
    },
    enabledDisableWebhooks(workflow) {
      workflow.webhookEnabled = !workflow.webhookEnabled;
      this.$store.dispatch("wfStore/updateWorkflow", {workflow: workflow});
      this.reload++;
    }
  }
};
</script>

<style scoped>
.workspaces-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 4rem;
}
.workspace-cell{
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 5px;
  border-style: solid;
  padding: 0.5rem;
}

.table-scroll {
  flex: 1;
  max-height: 500px;
  overflow-x: auto;
  overflow-y: auto;
}
.table-container {
  position: relative;
  height: calc(40vh - 50px);
  padding: 24px;
  top: 0px;
  overflow: auto;
}

.data-table {
  border-collapse: separate;
  border-spacing: 0 12px;
  width: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  color: #333;
  padding: 10px;
}

.data-table thead {
  position: sticky;
  background-color: #18242c;
}

.data-table th {
  top: 0;
  padding: 16px 8px;
  text-align: left;
  font-weight: 300;
  color: #f8fafc;
  border-bottom: 2px solid #1a202c;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  z-index: 2;
  height: 5vh;
}

.data-table tbody tr {
  background: white;
  transition: background-color 0.2s;
  height: 5vh;
}

.data-table tbody tr:hover {
  background-color: #f8fafc;
}

.data-table td {
  vertical-align: center;
  text-align: left;
  width: 10vw;
  font-size: 12px;
}


</style>



// WEBPACK FOOTER //
// src/components/workspace/WorkspaceSummary.vue